module.exports = __webpack_public_path__ + "static/media/menu_responsive.4952fb87.svg";